import { onUnmounted, ref } from "@vue/composition-api";

export default function useCountDown(durationInSeconds: number) {
  const timeLeft = ref(durationInSeconds);
  let interval: ReturnType<typeof setInterval> | null;
  const stop = () => {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  };

  const start = () => {
    if (interval) return;
    interval = setInterval(() => {
      if (timeLeft.value === 0) {
        timeLeft.value = durationInSeconds;
      } else {
        timeLeft.value = timeLeft.value - 1;
        if (timeLeft.value === 0) {
          stop();
        }
      }
    }, 1000);
  };
  const restart = () => {
    stop();
    timeLeft.value = 0;
    start();
  };
  onUnmounted(start);
  return {
    timeLeft,
    start,
    stop,
    restart,
  };
}
